import keys from '@debbie/common/dist/cache/keys.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as caseVouchersAPI from '@debbie/cortex/dist/api/case-vouchers.js';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers/index.js';
import { fixedDistributionsEntity } from '@debbie/cortex/dist/fixed-distributions/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { errorNotification } from '../../../utils/errors.js';
import { Button, Modal } from '../../index.js';
import MoneyInput from '../../MoneyInput.js';
import PillSelector from '../../PillSelector.js';
const ModalContent = styled.div ``;
const CounterEntryModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const [amount, setAmount] = useState(props.fullAmount);
    const mutation = useMutation(async () => {
        await caseVouchersAPI.createCounterEntry(props.caseVoucherId, amount);
        q.invalidate(keys.write.modify(caseVouchersEntity, props.caseVoucherId));
        q.invalidate(keys.write.create(fixedDistributionsEntity));
        props.onClose();
        props.onCreated();
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.caseVoucher);
        },
    });
    return (React.createElement(Modal, { maxWidth: "480px", onToggle: props.onClose, header: lang.economy.voucherInfoCreateCounterEntry },
        React.createElement(ModalContent, null,
            React.createElement(MoneyInput, { placeholder: lang.cases.amount, value: amount, onChange: (v) => setAmount(v), max: props.fullAmount, min: 0.01, autofocus: true, style: { marginBottom: '8px' } }),
            React.createElement(PillSelector, { value: [25, 50, 75, 100].find((pct) => amount ===
                    Math.round(props.fullAmount * (pct / 100) * 100) / 100) ?? null, onChange: (pct) => {
                    if (pct != null) {
                        setAmount(Math.round(props.fullAmount * (pct / 100) * 100) / 100);
                    }
                }, options: [25, 50, 75, 100].map((pct) => ({
                    key: String(pct),
                    value: pct,
                    label: `${pct}%`,
                })) }),
            React.createElement(Button, { style: { width: '100%', marginTop: 16 }, loading: mutation.isLoading, disabled: !amount || amount <= 0 || amount > props.fullAmount, onClick: () => mutation.mutate() }, lang.economy.voucherInfoCreateCounterEntry))));
};
export default CounterEntryModal;
//# sourceMappingURL=CounterEntryModal.js.map